import { useSelector } from "react-redux";
import { selectUser } from "../reducers/userSlice";
import { url_ws } from "./Datos";
//export const UrlWs = "https://gateway.penalolen.cl:9443";
//export const UrlWs = "https://gateway-vecinos.penalolen.cl:9443";
export const UrlWs =url_ws();

export const Global = () => {
  return {
    urlApi: "http://192.168.10.59:8080",
    cargos: ["Jefe", "Empleado"],
    escalafon: [
      "",
      "ADMINISTRATIVO",
      "ALCALDE",
      "AUXILIAR",
      "DIRECTIVO",
      "JEFATURA",
      "PROFESIONAL",
      "TECNICO",
    ],
    grado: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,16,17,18],
  };
};

/**
 * 
 * @param {*} rolesAceptados 
 *  ["ROL_ADMIN",
    "ROL_ADMIN_MUN",
    "ROL_PRECALIFICADOR",
    "ROL_JC_PRESIDENTE",
    "ROL_JC_SECRETARIO",
    "ROL_JC_REPRESENTANTE",
    "ROL_JC_MIEMBRO_UNO",
    "ROL_JC_MIEMBRO_DOS",
    "ROL_JC_PDTE_ASOC"]
 * @returns TRUE || FALSE
 */
export const Permisos = (rolesAceptados = [], tipo = "menu") => {
  const user = useSelector(selectUser);
  let rolesUsuario = [];

  if (typeof user.user.roles == "undefined" || user.user.roles ==null) {
    return false;
  } else if (user !== null) {
    rolesUsuario = user.user.roles.split(";");
  } else {
    return false;
  }
  if (
    !rolesAceptados.some((r) => rolesUsuario.includes(r)) &&
    tipo === "redirigir"
  ) {
    localStorage.setItem(
      "error",
      "No tiene los permisos para ingresar a la página."
    );
  } else {
    localStorage.removeItem("error");
  }

  return rolesAceptados.some((r) => rolesUsuario.includes(r));
};

export const Textos = {
  exito_actualizarParticipante: "Funcionario/a actualizado/a con éxito",
  comun_funcionario: "funcionario/a",
  comun_Funcionario: "Funcionario/a",
  comun_FUNCIONARIO: "FUNCIONARIO/A",
  comun_el_funcionario: "el/la funcionario/a",
  comun_Precalificador: "Precalificador/a",
};
